import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import {
  UploadBarcodesBody,
  UploadBarcodesForm,
} from 'src/components/UploadArtifacts/UploadBarcodes';
import { Stack } from 'src/core/ui';
import { PurchaseWizardFooter } from 'src/modals/common';
import { ContentId } from 'src/utils/constants/contentId';
import { posChangedField } from 'src/utils/posFieldUtils';
import { PurchaseTicketsInput } from 'src/utils/purchaseUtils';
import { toEntityWithTicket } from 'src/utils/ticketUtils';
import {
  ActionOutboxEntityType,
  PosClientConfig,
  PosUiActionResult,
  TicketBarcode,
} from 'src/WebApiController';

import {
  ticketGroupInputFooter,
  ticketGroupPredeliveryBody,
} from '../PurchaseTicketFlow.css';

export const UploadBarcodesSection = ({
  ticketGroupIndex,
  onCancel,
}: {
  ticketGroupIndex: number;
  onCancel: () => void;
}) => {
  const { setValue, watch } = useFormContext<PurchaseTicketsInput>();

  const ticketGroup = watch(`ticketGroups.${ticketGroupIndex}`);

  const onSubmit = (
    _: PosClientConfig,
    entityId: number,
    barcodes: TicketBarcode[]
  ) => {
    const newTickets = ticketGroup.tickets?.value?.map((t) => {
      const tb = barcodes.find((b) => b.ticketId === t.id);
      t.barcode = tb?.barcode ?? null;
      return { ...t };
    });

    setValue(
      `ticketGroups.${ticketGroupIndex}.tickets`,
      posChangedField(newTickets ?? null)
    );

    return Promise.resolve({
      status: 200,
      entityId,
      entityType: ActionOutboxEntityType.Purchase,
    } as PosUiActionResult);
  };
  const entityWithTickets = useMemo(
    () => toEntityWithTicket(ticketGroup),
    [ticketGroup]
  );

  return (
    <UploadBarcodesForm
      entityWithTickets={entityWithTickets}
      onComplete={onCancel}
      onUpload={onSubmit}
      renderContent={(onUploadClick: () => void, disabled?: boolean) => (
        <Stack direction="column" height="full" justifyContent="spaceBetween">
          <UploadBarcodesBody
            className={ticketGroupPredeliveryBody}
            isReadOnly={disabled}
            ticketCnt={entityWithTickets.ticketCnt}
            seating={entityWithTickets.seating}
          />
          <PurchaseWizardFooter
            className={ticketGroupInputFooter}
            disabled={disabled}
            onPrevious={onCancel}
            onPreviousLabel={ContentId.Cancel}
            onNext={onUploadClick}
            onNextLabel={ContentId.Save}
          />
        </Stack>
      )}
    />
  );
};
